export function env(http, enums, penv, user) {
  env.prototype.$http = http;
  env.prototype.$enum = enums;
  env.prototype.$user = user;
  env.prototype.conf = {};
  env.prototype.getConf(penv);
}

//getConf 获取环境配置文件m
env.prototype.getConf = function (m) {
  if (!m) {
    m = process.env;
  }
  env.prototype.env = m.VUE_APP_ENV || m.NODE_ENV || "development";
  env.prototype.conf_path = m.VUE_APP_CONF;
  if (!env.prototype.conf_path) {
    let name = env.prototype.env.substring(0, 3);
    env.prototype.conf_path = "/env.conf." + name + ".json";
  }

  //颜色
  let colorful = env.prototype.getColorfulClass();
  Object.assign(env.prototype.conf, colorful);

  //progress
  let progressColor = env.prototype.getProgressColor();
  Object.assign(env.prototype.conf, progressColor);

  let path = env.prototype.conf_path;
  let conf = env.prototype.$http.xget(path);
  if (conf) {
    Object.assign(env.prototype.conf, conf);
  }
  env.prototype.$http.setBaseURL(env.prototype.getApiHost());
  //处理系统信息
  env.prototype.getSystemInfo();
  if (env.prototype.conf.system && env.prototype.conf.system.theme) {
    env.prototype.setTheme(env.prototype.conf.system.theme);
  }

  //处理枚举
  env.prototype.$enum.set(env.prototype.conf.enums || []);
  env.prototype.$enum.callback(function (tp, url) {
    let u = url || "/enums/query";
    return env.prototype.$http.xpost(u, { type: tp}) || [];
  });
  env.prototype.$user.callback(function (tp) {
    return env.prototype.$http.xpost("/user/info/get") || [];
  });
};

//getApiHost 获取后面服务器地址
env.prototype.getApiHost = function () {
  return ((env.prototype.conf || {}).api || {}).host || "";
};
env.prototype.join = function (p) {
  if (p[0] == "/") {
    return env.prototype.getApiHost() + p;
  }
  return env.prototype.getApiHost() + "/" + p;
};

//getMenus 获取菜单信息
env.prototype.getMenus = function () {
  if (env.prototype.conf.menus) {
    return env.prototype.conf.menus;
  }
  env.prototype.conf.menus = env.prototype.$http.xget("/menu/list/get") || [];
  return env.prototype.conf.menus;
};

//getSystemInfo 获取系统信息
env.prototype.getSystemInfo = function () {
  if (env.prototype.conf.system) {
    return env.prototype.conf.system;
  }
  let conf = env.prototype.$http.xget("/system/info/get") || {};
  env.prototype.conf.system = {};
  Object.assign(env.prototype.conf.system, conf);
  return env.prototype.conf.system;
};
env.prototype.getColorfulClass = function () {
  return {
    colorful: {
      0: "text-success",
      1: "text-danger",
      2: "text-warning",
      3: "text-info",
      4: "text-danger",
      5: "text-warning",
      6: "text-info",
      7: "text-danger",
      8: "text-warning",
      9: "text-info",
      10: "text-danger",
      20: "text-warning",
      30: "text-info",
      40: "text-danger",
      50: "text-warning",
      60: "text-info",
      70: "text-danger",
      80: "text-warning",
      90: "text-info",
      98: "text-info",
      99: "text-info",
    },
    colorTag: {
      0: "success",
      1: "danger",
      2: "warning",
      3: "info",
      4: "danger",
      5: "warning",
      6: "info",
      7: "danger",
      8: "warning",
      9: "info",
      10: "danger",
      20: "warning",
      30: "info",
      40: "danger",
      50: "warning",
      60: "info",
      70: "danger",
      80: "warning",
      90: "info",
      98: "info",
      99: "info",
    },
  };
};
env.prototype.getProgressColor = function () {
  return {
    progress: [
      {
        color: "#f56c6c",
        percentage: 20,
      },
      {
        color: "#e6a23c",
        percentage: 40,
      },
      {
        color: "#5cb87a",
        percentage: 60,
      },
      {
        color: "#1989fa",
        percentage: 80,
      },
      {
        color: "#6f7ad3",
        percentage: 100,
      },
    ],
  };
};
env.prototype.getTheme = function (theme) {
  if (!theme) {
    return {};
  }
  const ts = theme.split(" ");
  let ntheme = {};
  ntheme.active_bg_color = ts.length > 0 ? ts[0] : ""; //banner,menu active
  ntheme.menu_bg_color = ts.length > 1 ? ts[1] : ""; //left main menu
  ntheme.button_bg_color = ts.length > 2 ? ts[2] : ""; //button
  ntheme.footer_bg_color = ts.length > 3 ? ts[3] : ""; //footer
  ntheme.bg_color = ts.length > 4 ? ts[4] : ""; //bg
  return ntheme;
};
env.prototype.setTheme = function (theme) {
  let ntheme = env.prototype.getTheme(theme);

  // 设置banner颜色，菜单激活颜色
  if (ntheme.active_bg_color) {
    document.documentElement.style.setProperty(
      "--banner-bg-color",
      ntheme.active_bg_color
    );
    document.documentElement.style.setProperty(
      "--menu-active-bg-color",
      ntheme.active_bg_color
    );
  }

  // 设置菜单背影颜色
  if (ntheme.menu_bg_color) {
    document.documentElement.style.setProperty(
      "--menu-bg-color",
      ntheme.menu_bg_color
    );
  }

  if (ntheme.button_bg_color) {
    document.documentElement.style.setProperty(
      "--button-bg-color",
      ntheme.button_bg_color
    );
  }

  // 设置页脚颜色
  if (ntheme.footer_bg_color) {
    document.documentElement.style.setProperty(
      "--footer-bg-color",
      ntheme.footer_bg_color
    );
  }
  // 设置页面颜色
  if (ntheme.bg_color) {
    document.documentElement.style.setProperty("--bg-color", ntheme.bg_color);
  }
};
